<template>
	<div class="guess container main pt-40 border-l">
		<form id="guess-cards-form">
			<h1 class="main-header">It's your turn</h1>

			<div class="value select-wrapper">
				<select
					name="guess-value"
					id="guess-value"
					required
					v-model="guessValue"
					@change="showSuitsMethod"
				>
					<option disabled selected>{{ placeholder }}</option>
					<option
						v-for="cardValue in defaultValues"
						:value="cardValue"
						:key="cardValue"
						>{{ cardValue }}</option
					>
				</select>
			</div>
			<transition name="fade-suits">
				<div
					v-if="showSuits"
					id="guess-suits-div"
					class="suits container"
				>
					<div
						v-for="(suit, index) in defaultSuits"
						:key="index"
						class="suit select-wrapper"
					>
						<label :class="suit" :for="'guess-' + suit"
							><span v-html="emojify(suit)"></span
						></label>
						<select
							v-model="guessSuits[suit]"
							:id="'guess-' + suit"
							class="guess-suit-select select"
							required
						>
							<option value="" disabled selected hidden>
								Select player...
							</option>
							<option
								v-for="player in players"
								:key="player.pos"
								:value="player.pos"
								@mouseover="handleHover"
								>{{ player.pos }} {{ player.name }}</option
							>
						</select>
					</div>
				</div>
			</transition>
			<div class="buttons">
				<secondary-button @click="tryPassTurn"
					>Pass turn</secondary-button
				>
				<primary-button
					:disabled="!readyToGuess"
					:class="{ disabled: !readyToGuess }"
					@click="handleGuess"
					>Guess</primary-button
				>
			</div>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrimaryButton from "./ui/PrimaryButton";
import SecondaryButton from "./ui/SecondaryButton";

export default {
	props: ["guessValueProp"],
	data() {
		return {
			showSuits: false,
			guessValue: "",
			placeholder: "Select value...",
			guessSuits: {},
		};
	},
	computed: {
		...mapGetters([
			"joined",
			"values",
			"suits",
			"me",
			"autofill",
			"myCardsArray",
			"players",
		]),
		defaultValues() {
			if (this.joined) {
				return this.values;
			} else {
				return null;
			}
		},
		defaultSuits() {
			if (this.joined) {
				return this.suits;
			} else {
				return null;
			}
		},
		readyToGuess() {
			return (
				this.guessValue &&
				this.suits.every(
					suit => typeof this.guessSuits[suit] === "number"
				)
			);
		},
	},
	components: {
		PrimaryButton,
		SecondaryButton,
	},
	emits: {
		"pass-turn": null,
		"change-guess-form-key": null,
	},
	methods: {
		...mapActions(["devController", "tryCheckGuess", "tryPassTurn"]),
		showSuitsMethod() {
			this.showSuits = true;
			this.guessSuits = {};
			if (this.autofill) {
				this.myCardsArray.forEach(card => {
					// console.log("HERE IS A CARD", card);
					if (card.value === this.guessValue) {
						this.guessSuits[card.suit] = this.me;
					}
				});
			}
		},
		passTurnEvent() {
			this.tryPassTurn;
		},
		selectValue(aValue) {
			// console.log("SELECTED", aValue);
			this.guessValue = aValue;
			this.showSuits = true;
		},

		handleGuess() {
			console.log(
				"JUST CHECKING:",
				this.suits.every(suit => this.guessSuits[suit])
			);
			if (this.readyToGuess) {
				// console.log(">>> GUESS VALUE");
				console.log("PAYLOAD", {
					value: this.guessValue,
					suits: this.guessSuits,
				});
				this.tryCheckGuess({
					value: this.guessValue,
					suits: this.guessSuits,
				});
			}
		},
		emojify(str) {
			switch (str) {
				case "clubs":
					return "&clubs;";
				case "diamonds":
					return "&diams;";
				case "hearts":
					return "&hearts;";
				case "spades":
					return "&spades;";
				default:
					return str;
			}
		},
		playerArrow(pos) {
			let direction = (4 + pos - this.me) % 4;
			if (direction === 0) return "&darr;";
			if (direction === 1) return "&larr;";
			if (direction === 2) return "&uarr;";
			if (direction === 3) return "&rarr;";
		},
		handleSuitChange() {
			this.$emit("select-suit-change", {
				pos: this.selectedPlayer,
				suit: this.suit,
			});
		},
		handleHover() {
			// console.log("HOVERING!");
		},
	},
	watch: {
		guessValueProp(newVal) {
			this.showSuits = false;
			this.guessValue = newVal;
			this.selectValue(newVal);
			this.showSuitsMethod();
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

// Guess section
.guess {
	z-index: 1000;
	// For whole container
	&.container {
		width: 340px;
	}

	// Label + select wrapping div
	.select-wrapper {
		margin: 1em auto;
		display: flex;

		* {
			vertical-align: middle;
		}

		label {
			font-size: 1.5em;
			margin-right: 0.5em;
		}

		select {
			// -moz-appearance: none;
			-webkit-appearance: none;

			padding: 0.65em 1em;
			width: 100%;
			border-radius: $border-m;

			background-color: $blue-darkest;
			color: white;
			font-size: 1em;

			cursor: pointer;

			&:hover {
				background-color: darken($blue-darkest, 2%);
			}
			&:active {
				background-color: darken($blue-darkest, 5%);
			}
			transition-duration: $trd-m;
		}
	}

	// Styling for card value
	.value {
		width: 100% !important;
		select {
			width: 100% !important;
		}
	}

	// Styling for card suits div
	.suits {
		// For each wrapper div
		.suit.select-wrapper {
			select:invalid {
				color: $blue-lighter;
			}
		}
		// Styling for card suits div
		// For each wrapper div
		.suit.select-wrapper {
			select:invalid {
				color: $blue-lighter;
			}
		}
		.select-wrapper {
			margin: 1em auto;
			display: flex;

			* {
				vertical-align: middle;
			}

			label {
				font-size: 1.5em;
				margin-right: 0.5em;
				min-width: 20px;
				&.spades,
				&.clubs {
					color: $white;
				}
				&.hearts,
				&.diamonds {
					color: $red;
				}
			}

			select {
				// -moz-appearance: none;
				-webkit-appearance: none;

				padding: 0.65em 1em;
				width: 100%;
				border-radius: $border-m;

				background-color: $blue-darkest;
				color: white;
				font-size: 1em;

				option:hover {
					background-color: red;
				}

				cursor: pointer;

				&:hover {
					background-color: darken($blue-darkest, 2%);
				}
				&:active {
					background-color: darken($blue-darkest, 5%);
				}
				transition-duration: $trd-m;
			}
		}
	}

	// Styling for buttons div
	.buttons {
		margin-top: 32px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 16px;

		// For each button
		.btn {
			padding: 1em 1.5em;
		}
	}
}

.fade-suits-enter-active,
.fade-suits-leave-active {
	transition: all 0.3s ease-out;
}

.fade-suits-enter-from,
.fade-suits-leave-to {
	transform: translateY(-10px);
	opacity: 0;
}
</style>
